import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const CareerToggleTabs = () => {
  const [activeToggle, setActiveToggle] = useState(null);

  const handleToggle = (toggleId) => {
    setActiveToggle(activeToggle === toggleId ? null : toggleId);
  };

  return (
    <>
      <div className="career-toggle1 fade-in-down">
        <h5
          className="career-toggle1-title"
          onClick={() => handleToggle("toggle1")}
          style={{
            color: activeToggle === "toggle1" ? "#000" : "#666", // Change color based on toggle state
          }}
        >
          Graphics Designing Internee (1 Position)
          <span>{activeToggle === "toggle1" ? <FaMinus /> : <FaPlus />}</span>
        </h5>
        <div
          className="career-toggle1-content"
          style={{
            maxHeight: activeToggle === "toggle1" ? "1000px" : "0", // Dynamically adjust height
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for a Graphic Designer Internee with strong layout
            skills and understanding of UI/UX concepts for mobile, tablets
            & web. He/She will be responsible for creating great Web apps
            and having excellent visual design expertise and be proficient in
            graphic design.
          </p>
          <ul>
            <li>Illustrate concept by designing rough layout of art and copy regarding arrangement, size, type size and style, and related aesthetic concepts.</li>
            <li>Proofreading to produce accurate and high-quality work.</li>
            <li>Working as part of a team.</li>
            <li>Ability to interact, communicate and present ideas.</li>
            <li>Possession of creative flair, versatility, conceptual/visual ability, originality and familiarity with design software and technologies (such as InDesign, Illustrator, Dreamweaver, Photoshop).</li>
            <li>Using innovation to redefine a design brief within the constraints of cost and time.</li>
            <li>Ability to complete projects with minimal supervision.</li>
          </ul>
          <div className="career-apply-button1-container">
            <a className="career-apply-button1" href="mailto:jobs@softisans.com" target="_blank" rel="noopener noreferrer">Apply Now</a>
          </div>
        </div>
      </div>
      <div className="career-toggle2 fade-in-down">
        <h5
          className="career-toggle2-title"
          onClick={() => handleToggle("toggle2")}
          style={{
            color: activeToggle === "toggle2" ? "#000" : "#666", // Change color based on toggle state
          }}
        >
          PHP Laravel Internee (1 Position)
          <span>{activeToggle === "toggle2" ? <FaMinus /> : <FaPlus />}</span>
        </h5>
        <div
          className="career-toggle2-content"
          style={{
            maxHeight: activeToggle === "toggle2" ? "1000px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for PHP Laravel Internee. On successful completion of
            the internship program, the ideal candidate will be hired as a
            full-time Developer in the company.
          </p>
          <b>Requirements:</b>
          <ul>
            <li>Graduated in computer science, IT or in Software Engineering.</li>
            <li>Willing to pursue his career in PHP – Laravel.</li>
            <li>Familiar with MVC architecture and frameworks.</li>
            <li>Familiar with JavaScript, JQuery, Ajax, Bootstrap.</li>
            <li>Open to learning and researching about the latest tools and technologies.</li>
            <li>Able to meet the deadlines and can handle pressure.</li>
            <li>Good in communication.</li>
          </ul>
          <div className="career-apply-button2-container">
            <a className="career-apply-button2" href="skype:rizwan-ali?call" target="_blank" rel="noopener noreferrer">Apply Now</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerToggleTabs;
